import React from "react";
import {
  BrowserRouter,
  Navigate,
  Route,
  Routes,
} from "react-router-dom";
import ClinicOnboardingMapPage from "./modules/clinicOnboarding/pages/ClinicOnboardingMapPage";
import ClinicOnboardingPage from "./modules/clinicOnboarding/pages/ClinicOnboardingPage";

const App = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<ClinicOnboardingPage />} />
        <Route path="/map-view" element={<ClinicOnboardingMapPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
};

export default App;
